module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-page-layout', {
    attrs: {
      "config": _vm.pageConfig
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": [_vm.service]
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "维修订单"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.OrderCode) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单来源"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(_vm._f("OrderSource")(props.row.OriginalOrderType)) + " "), (props.row.OriginalOrderType != null) ? _c('span', {
          staticStyle: {
            "color": "#20a0ff"
          }
        }, [_vm._v("(" + _vm._s(props.row.OriginalOrderCode) + ")")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "维修类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(_vm._f("RepairType")(props.row.RepairType)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "区域"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return void 0
      }
    }])
  })], 1), _vm._v(" "), _c('h3', {
    staticStyle: {
      "line-height": "2em",
      "font-size": "14px"
    }
  }, [_vm._v("物料清单")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": _vm.servicelist,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "批次号",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.LotCode) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料名称",
      "width": "260"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-col', [_vm._v(_vm._s(props.row.ProductName))]), _vm._v(" "), _c('el-col', [_vm._v("物料编码：" + _vm._s(props.row.ProductCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料品项"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(props.row.ConditionName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.BrandName) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "机型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.ModelName) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.ModuleName) + "\n      ")]
      }
    }])
  }), _vm._v(" "), (_vm.service.State == 'receiving') ? _c('el-table-column', {
    attrs: {
      "label": "收货状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(_vm.PickingState(props)) + "\n      ")]
      }
    }])
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "维修原因"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          nativeOn: {
            "click": function($event) {
              _vm.repairreason(props)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  }), _vm._v(" "), (_vm.service.State != 'receiving') ? _c('el-table-column', {
    attrs: {
      "label": "质检结果"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(_vm.service.State != 'qc' &&
          _vm.service.State != 'draft' &&
          _vm.service.State != 'receiving') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          nativeOn: {
            "click": function($event) {
              _vm.resultBox(props.$index)
            }
          }
        }, [_vm._v("查看")]) : _c('span', [_vm._v("－")])]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.service.State == 'repairing') ? _c('el-table-column', {
    attrs: {
      "label": "维修费用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        ¥" + _vm._s(props.row.RepairAmount) + "\n      ")]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.service.State == 'finished') ? _c('el-table-column', {
    attrs: {
      "label": "维修结果"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(_vm._f("RepairLotResult")(props.row.RepairOrderLineResult)) + "\n      ")]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.service.State == 'finished') ? _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(_vm.itemState(props)) + "\n      ")]
      }
    }])
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "pop-box",
    attrs: {
      "title": "维修原因",
      "size": "small"
    },
    model: {
      value: (_vm.repairReasonFormVisible),
      callback: function($$v) {
        _vm.repairReasonFormVisible = $$v
      },
      expression: "repairReasonFormVisible"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.repairReason))]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.repairReasonFormVisible = false
      }
    }
  }, [_vm._v("确认")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "pop-box review-table",
    attrs: {
      "title": "质检结果",
      "size": "large"
    },
    model: {
      value: (_vm.resultFormVisible),
      callback: function($$v) {
        _vm.resultFormVisible = $$v
      },
      expression: "resultFormVisible"
    }
  }, [_c('h5', [_vm._v("批次清单")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('td', [_vm._v("批次号")]), _vm._v(" "), _c('td', [_vm._v("物料名称")]), _vm._v(" "), _c('td', [_vm._v("物料品项")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.qcLines.Lot.Code))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.qcLines.Product.Name)), _c('br'), _vm._v("\n              物料编码：" + _vm._s(_vm.qcLines.Product.Code) + "\n            ")]), _vm._v(" "), _c('td', [_c('el-tag', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.qcLines.Condition.Name))])], 1)])])]), _vm._v(" "), _c('p', [_vm._v("检测建议：" + _vm._s(_vm._f("SuggestionChange")(_vm.qcLines.Suggestion)))]), _vm._v(" "), _c('p', [_vm._v("质检报告：" + _vm._s(_vm.qcLines.Report))]), _vm._v(" "), _c('h5', [_vm._v("维修配件")]), _vm._v(" "), _vm._l((_vm.qcLines.PartsProcurementLines), function(item) {
    return _c('div', {
      staticClass: "replacement"
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_vm._v("\n            物料名称\n            "), _c('span', [_vm._v(_vm._s(item.Product.Name))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_vm._v("\n            物料编码\n            "), _c('span', [_vm._v(_vm._s(item.Product.Code))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_vm._v("\n            数量\n            "), _c('span', [_vm._v(_vm._s(item.Quantity))])])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.resultFormVisible = false
      }
    }
  }, [_vm._v("确认")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c220ce28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Repair/RepairDetailPage.vue
// module id = 768
// module chunks = 0